<script lang="ts">
    import { sendUIInteractionAnalyticsEvent } from "@app/services/analytics/analytics-send-event";

    import {
        COMMON__aboutAuthor,
        COMMON__details,
        DICTIONARY__excludeAuthor,
        DICTIONARY__onlyThisAuthor,
        FORM__Cancel,
    } from "@app/services/i18n.messages";
    import { getMessage } from "@app/services/i18n.service";
    import Menu from "../Menu.svelte";
    import {
        tmemState,
        toggleExcludeAuthor,
        toggleIncludeAuthor,
    } from "./TmemState";

    export let open: boolean;
    export let onClose: () => void;
    export let exampleId: string;
    export let authorId: string;
    export let authorName: string;
    function hideAuthorExamples() {
        toggleExcludeAuthor({ id: authorId, name: authorName });
        sendUIInteractionAnalyticsEvent({
            action: "tmem-menu-hide-author",
        });
    }

    function showOnlyAuthorExamples() {
        toggleIncludeAuthor({ id: authorId, name: authorName });
        sendUIInteractionAnalyticsEvent({
            action: "tmem-menu-only-author",
        });
    }
</script>

<Menu {open} {onClose}>
    <li>
        <button
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700
                tmem__item__menu__this_author_only"
            data-authorid={authorId}
            data-authorname={authorName}
            on:click={showOnlyAuthorExamples}
        >
            {$tmemState.includedAuthors.find((a) => a.id == authorId)
                ? getMessage(FORM__Cancel) + ": "
                : ""}
            {getMessage(DICTIONARY__onlyThisAuthor)}
        </button>
    </li>
    <li>
        <button
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700
                tmem__item__menu__exclude_author"
            data-authorid={authorId}
            data-authorname={authorName}
            on:click={hideAuthorExamples}
        >
            {getMessage(DICTIONARY__excludeAuthor)}
        </button>
    </li>
    <li>
        <a
            href="https://app.glosbe.com/tmem/show?id={exampleId}"
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
        >
            {getMessage(COMMON__details)}
        </a>
    </li>
    <li>
        <a
            href="https://app.glosbe.com/source/{authorId}"
            class="px-4 py-2 block w-full h-full hover:bg-gray-100 text-gray-700"
            rel="nofollow"
        >
            {getMessage(COMMON__aboutAuthor)}
        </a>
    </li>
</Menu>
